/* Keep the floating chat launcher clear of purchase controls, including sticky forms. */
(() => {
  let pending = false;
  const update = () => {
    pending = false;
    const host = document.querySelector('shopify-chat');
    const launcher = host?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part="activator"]');
    if (!launcher) return;
    if (launcher.getAttribute('aria-expanded') === 'true') { document.body.classList.remove('pl-chat-clear'); return; }
    const r = launcher.getBoundingClientRect();
    const overlaps = [...document.querySelectorAll('.product-form__submit, [id^="QuantityForm-"], product-sticky-form button, .pl-seasonal__card, .pg-gifts .card, .pl-bestsellers__card, .pl-original-kit-delivery, .pl-original-kit-contents, .pl-original-kit-more')].some(button => {
      const s = getComputedStyle(button), b = button.getBoundingClientRect();
      return s.visibility !== 'hidden' && s.opacity !== '0' && s.pointerEvents !== 'none' && b.width > 0 && b.height > 0 && b.top < innerHeight && b.bottom > 0 && r.left < b.right + 8 && r.right > b.left - 8 && r.top < b.bottom + 8 && r.bottom > b.top - 8;
    });
    document.body.classList.toggle('pl-chat-clear', overlaps);
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
  addEventListener('scroll', schedule, {passive:true}); addEventListener('resize', schedule); addEventListener('load', schedule);
  new IntersectionObserver(schedule).observe(document.querySelector('main') || document.body);
  const observer = new MutationObserver(schedule); observer.observe(document.body, {childList:true,subtree:true});
  schedule();
})();
